import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "./Button";
import { useTranslation } from "react-i18next";

declare global {
  interface Window {
    ml?: (...args: any[]) => void;
  }
}

interface BookButtonProps {
  className?: string;
}

export const BookButton: React.FC<BookButtonProps> = ({ className }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { i18n } = useTranslation();

  const handleShowForm = () => {
    const url = new URL(window.location.href);
    url.searchParams.set("show-popup", "true");
    navigate(url.pathname + url.search, { replace: true });

    const updatedUrl = new URL(window.location.href);
    updatedUrl.searchParams.delete("show-popup");
    navigate(updatedUrl.pathname + updatedUrl.search, { replace: true });
    const modal = i18n.language === "de" ? "y88jMo" : "AkrAjq";
    if (window.ml) {
      window.ml("show", modal, true);
    } else {
      console.error(
        "Oops! MailerLite took too long to load. Please try again later."
      );
    }
  };

  return (
    <Button
      label={t("buttons.book_a_demo")}
      className={className}
      onClick={handleShowForm}
      buttonId="book-button"
    />
  );
};
